import BaseModel from './BaseModel'

export default class File extends BaseModel {
  get absoluteUrl() {
    return process.env.RESOURCE_BASE_URL + this.path
  }
}
